/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import RadiologyBillItem from './radiology-bill-item';
import RadiologyBillItemDetail from './radiology-bill-item-detail';
import RadiologyBillItemUpdate from './radiology-bill-item-update';
import RadiologyBillItemDeleteDialog from './radiology-bill-item-delete-dialog';

const RadiologyBillItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<RadiologyBillItem />} />
    <Route path="new" element={<RadiologyBillItemUpdate />} />
    <Route path=":id">
      <Route index element={<RadiologyBillItemDetail />} />
      <Route path="edit" element={<RadiologyBillItemUpdate />} />
      <Route path="delete" element={<RadiologyBillItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default RadiologyBillItemRoutes;
